import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { Button, Card, Input } from '@clari/ui'
import { ErrorBanner } from '@/components/ErrorBanner'
import { apiErrorMessage } from '@/lib/api-error'
import { bankingApi } from '@/lib/banking-api'

export function CardNew() {
  const { t } = useTranslation('banking')
  const navigate = useNavigate()
  const accountsQuery = useQuery({ queryKey: ['accounts'], queryFn: () => bankingApi.listAccounts() })
  const account = accountsQuery.data?.items[0]
  const [limit, setLimit] = useState('1000')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()
    if (!account) return
    setError(null)
    setLoading(true)
    try {
      const cents = Math.round(Number.parseFloat(limit.replace(',', '.')) * 100)
      const res = await bankingApi.issueCard(account.id, cents)
      navigate(`/app/cards/${res.card.id}`, { replace: true })
    } catch (err) {
      setError(apiErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="mx-auto max-w-md">
      <Card>
        <h1 className="text-2xl font-semibold">{t('cards.new')}</h1>
        <form className="mt-6 flex flex-col gap-4" onSubmit={onSubmit}>
          <Input
            label={t('cards.spending_limit')}
            inputMode="decimal"
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
            required
          />
          {error ? <ErrorBanner message={error} /> : null}
          <Button type="submit" disabled={loading || !account}>
            {t('cards.issue')}
          </Button>
        </form>
      </Card>
    </div>
  )
}
